<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100"
      v-if="dataPermission.includes('CNPS_DEVICE_VIEW')"
    >
      <h1>Chi tiết vật tư</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail">
                  <h1>Thông tin vật tư</h1>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Kho đang quản lý<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.inventoryName }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Thủ kho<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.keeper && detail.keeper.name }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Quản lý kho<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.manager && detail.manager.name }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Tên vật tư<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.categoryName }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row" v-if="type === 'status'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <span class="badge" :class="[detail.deviceStatus ? detail.deviceStatus : '']">
                        {{ detail.deviceStatus | transformData(optionStatus) }}
                      </span>
                    </div>
                  </div>

                  <div class="form-group form-row" v-if="type === 'status'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Số lượng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.quantity }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row" v-if="type === 'warehouse'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Tổng số lượng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.quantity }}</p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="type === 'warehouse'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Số lượng khả dụng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.quantity - detail.lockedQuantity }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <b-table
                    :busy.sync="showLoading"
                    sticky-header
                    hover
                    responsive
                    :items="dataMaterial"
                    :fields="filterTable"
                    :bordered="true"
                  >
                    <template #table-busy>
                      <div class="my-2 text-center">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>
                    <template #cell(index)="data">
                      {{ getIndex(data.index) }}
                    </template>
                    <template #cell(time)="data">
                      {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </template>
                    <template #cell(reason)="data">
                      {{ data.item.reason | transformData(reasonMaterial) }}
                    </template>
                    <template #cell(type)="data">
                      {{ data.item.type | transformData(Config.typeBill) }}
                    </template>
                    <template #cell(status)="data">
                      <span class="badge" :class="[data.item.status ? data.item.status : '']">
                        {{ data.item.status | transformData(Config.statusWarehouse) }}
                      </span>
                    </template>
                    <template #cell(userCreator)="data">
                      {{ data.item.userCreator && data.item.userCreator.name }}
                    </template>
                    <template #cell(personApprove)="data">
                      {{ data.item.personApprove && data.item.personApprove.name }}
                    </template>
                  </b-table>
                  <div class="pagination-bottom">
                    <b-pagination
                      class="fl-right col-sm-4"
                      v-model="search.page"
                      :total-rows="pagination.total"
                      :per-page="search.limit"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '../../../thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian tạo' },
    { key: 'type', label: 'Loại phiếu' },
    { key: 'billNumber', label: 'Mã phiếu' },
    { key: 'reason', label: 'Lý do' },
    { key: 'inventoryNameImport', label: 'Kho nhập' },
    { key: 'inventoryNameExport', label: 'Kho xuất' },
    { key: 'quantity', label: 'Số lượng' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'userCreator', label: 'Người tạo' },
    { key: 'personApprove', label: 'Người duyệt/từ chối' },
  ]
  export default {
    name: 'detail-material',
    data() {
      return {
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        id: this.$route.params.id,
        detail: {},
        Config,
        search: {
          limit: 20,
          page: 1,
          id: this.$route.params.id,
        },
        dataMaterial: [],
        pagination: {
          total: 0,
        },
        optionStatus: Config.statusDevices,
        type: this.$route.params.type,
        reasonMaterial: [
          ...Config.reasonTransferWarehouse,
          ...Config.reasonImportWarehouse,
          ...Config.reasonExport,
        ],
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.page': function () {
        this.checkFetchData()
      },
    },

    created() {
      this.checkFetchData()
    },

    methods: {
      checkFetchData() {
        if (this.$route.params.type === 'warehouse') {
          this.fetchData()
          this.fetchDataHis()
        } else {
          this.fetchDataStatus()
        }
      },
      backToList() {
        if (this.$route.params.type === 'warehouse') {
          this.$router.push('/material/list/warehouse')
        } else this.$router.push('/material/list/status')
      },
      async fetchData() {
        try {
          this.showLoading = true
          const data = await DeviceService.detailDevice({
            id: this.id,
          })
          if (data.success || data.code === 1000) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDataHis() {
        try {
          this.showLoading = true
          const data = await DeviceService.detailDeviceHistory(this.search)
          if (data.success || data.code === 1000) {
            this.dataMaterial = data.data.deviceHistoryResList
            this.pagination.total = data.data.total ? data.data.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDataStatus() {
        try {
          this.showLoading = true
          const data = await DeviceService.detailDeviceStatus({
            id: this.id,
          })
          if (data.success || data.code === 1000) {
            this.detail = data.data
            this.fetchDataHisStatus(
              data.data.categoryId,
              data.data.deviceStatus,
              data.data.inventoryId
            )
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchDataHisStatus(categoryId, deviceStatus, inventoryId) {
        try {
          this.showLoading = true
          const params = cloneDeep(this.search)
          delete params.id
          params.categoryId = categoryId
          params.deviceStatus = deviceStatus
          params.inventoryId = inventoryId
          const data = await DeviceService.detailDeviceHistoryStatus(params)
          if (data.success || data.code === 1000) {
            this.dataMaterial = data.data.deviceHistoryResList
            this.pagination.total = data.data.total ? data.data.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
